/** The fixed rules a code check can apply, as cards: name and when to use it. */

import type { CodeCheck } from "./types";

export function CheckPicker({
  checks,
  value,
  onChange,
}: {
  checks: CodeCheck[];
  value: string | null;
  onChange: (check: string) => void;
}) {
  return (
    <fieldset className="flex flex-col gap-1.5">
      <legend className="mb-1.5 text-[13px] font-semibold">Check</legend>
      <div role="radiogroup" aria-label="Check" className="grid gap-2 sm:grid-cols-2">
        {checks.map((c) => {
          const on = c.check === value;
          return (
            <label
              key={c.check}
              className={`flex cursor-pointer flex-col gap-0.5 rounded-lg border px-3 py-2.5 ${on ? "border-ink bg-subtle" : "border-line hover:bg-hover"}`}
            >
              <span className="flex items-center gap-2 text-[13px] font-medium">
                <input
                  type="radio"
                  name="code-check"
                  className="size-3.5 accent-ink"
                  checked={on}
                  onChange={() => onChange(c.check)}
                />
                {c.name}
              </span>
              <span className="text-xs leading-snug text-muted">{c.use_when}</span>
            </label>
          );
        })}
      </div>
    </fieldset>
  );
}
